import React from 'react';

import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import WhitelabelIcon from '~/icons/components/WhitelabelIcon';
import { MIN_REVIEW_COUNT } from '~/shared/constants/reviews';
import useSecondarySite from '~/shared/utils/useSecondarySite';
import {
  mobile,
  Button,
  useProductReviews,
  useReviewsDrawer,
  useProductContext,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import RecentReviews from '../../../pdp/components/RecentReviews';

const MoreReviewsButton = styled(Button)`
  ${({ theme }) => theme.moreReviewsButton};
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 16px;
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.textDefault};

  ${mobile`
    font-size: 16px;
  `}
`;

const reviewStarsProps = {
  emptyIcon: <WhitelabelIcon iconName="emptyStar" />,
  fullIcon: <WhitelabelIcon iconName="filledStar" />,
};

export default function ProductReviews({
  onOpenDrawer,
  isSeoPage,
  reviewCount,
  loading,
  pageSize,
}) {
  const { permalink } = useProductContext();
  const { recentReviewsStyle } = useTheme();
  const { openPhotoDrawer } = useReviewsDrawer();
  const { reviews } = useProductReviews();
  const secondarySite = useSecondarySite();
  const routePrefix = secondarySite ? `/${secondarySite}` : '';

  if (!reviews.length) {
    return null;
  }

  const shouldRenderButton = isSeoPage ? false : reviewCount > MIN_REVIEW_COUNT;

  return (
    <>
      {!isSeoPage && (
        <Title>
          <FormattedMessage
            id="site_pdp.recent_reviews_header"
            defaultMessage="Recent Reviews"
          />
        </Title>
      )}
      <RecentReviews
        loading={loading}
        onPictureClick={openPhotoDrawer}
        pageSize={pageSize}
        reviewStarProps={reviewStarsProps}
        {...recentReviewsStyle}
      />
      {shouldRenderButton && (
        <MoreReviewsButton
          onClick={onOpenDrawer}
          href={`${routePrefix}/reviews/${permalink}`}
        >
          <FormattedMessage
            id="site_pdp.reviews_see_more_cta"
            defaultMessage="See More Reviews"
          />
        </MoreReviewsButton>
      )}
    </>
  );
}

ProductReviews.propTypes = {
  isSeoPage: PropTypes.bool,
  loading: PropTypes.bool,
  onOpenDrawer: PropTypes.func,
  pageSize: PropTypes.number,
  recentReviewsStyle: PropTypes.object,
  reviewCount: PropTypes.number,
};
